import React from 'react';

import VerticalBars from '../../../components/charts/chartjs/sonar-vertical-bars/SonarVerticalBars';
import { SONAR_DATA_KEYS } from '../../../utils/chart';

function PresenceTrend({ domainEntries }) {
  //! TEMPORARY SOLUTION
  let tempDomainEntries = domainEntries;

  if (domainEntries.length && !domainEntries[0][SONAR_DATA_KEYS.PRESENCE]) {
    tempDomainEntries = [];
  }

  return (
    <VerticalBars data={tempDomainEntries} dataKey={SONAR_DATA_KEYS.PRESENCE} height='400px' customTooltip showTrend />
  );
}

export default PresenceTrend;
